import React, { Fragment, useState, useRef } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import moment from "moment";
import { faDownload, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../AdminPages.css";

const SftpDetails = () => {
  const [districtName, setDistrictName] = useState();
  const [showDistrictNameContainer, setShowDistrictNameContainer] = useState(
    false
  );
  const [districtNameList, setDistrictNameList] = useState();
  const [districtID, setDistrictID] = useState();
  const [pageData, setPageData] = useState();
  const districtNameRef = useRef();
  const timeoutRef = useRef();
  const [districtNameLoading, setDistrictNameLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [clickedSchool, setClickedSchool] = useState();

  const getDistrictsList = (value) => {
    setDistrictNameLoading(true);
    GetAdminService.getDistrictsList(value)
      .then((data) => {
        setDistrictNameList(data?.data?.objects);
        setDistrictNameLoading(false);
        setShowDistrictNameContainer(true);
      })
      .catch(() => {
        setDistrictNameLoading(false);
      });
  };

  const downloadReport = () => {
    if (downloadLoading) return;
    setDownloadLoading(true);
    GetAdminService.downloadSFTPReport()
      .then((data) => {
        if (data && data.data && data.data.download) {
          window.open(data.data.download);
        }
      })
      .catch(() => {})
      .finally(() => {
        setDownloadLoading(false);
      });
  };

  const handleDistrictName = () => {
    clearTimeout(timeoutRef.current);
    setDistrictName(districtNameRef.current.value);
    if (!districtNameRef.current.value) {
      setShowDistrictNameContainer(false);
      setDistrictNameList([]);
      setPageData([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getDistrictsList(districtNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedDistrictName = (item) => {
    setDistrictID(item?.id);
    setDistrictNameList([item]);
    setShowDistrictNameContainer(false);
    setDistrictName(item.name);
    getDistrictPage(item?.id);
  };

  const getDistrictPage = (id) => {
    let obj = {
      district: id,
    };
    setLoading(true);
    GetAdminService.districtSftpPage(obj)
      .then((data) => {
        setPageData(data?.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>SFTP Information</h2>
              <button
                onClick={downloadReport}
                className="admin-students-new-btn"
                disabled={downloadLoading}
              >
                {downloadLoading ? (
                  <FontAwesomeIcon icon={faSpinner} spin />
                ) : (
                  <FontAwesomeIcon icon={faDownload} />
                )}
                SFTP Report for All Districts
              </button>
            </div>

            <div className="admin-students-school-selector">
              <label>Select District</label>
              <div className="school-input-wrapper">
                <input
                  ref={districtNameRef}
                  type="text"
                  placeholder="Type to search district name..."
                  value={districtName}
                  onChange={handleDistrictName}
                  autoComplete="off"
                />
                {showDistrictNameContainer && (
                  <ul className="school-dropdown">
                    {districtNameLoading && <CustomLoader />}
                    {districtNameList?.length > 0 &&
                      districtNameList.map((item, index) => (
                        <li
                          onClick={() => handleSelectedDistrictName(item)}
                          key={index}
                        >
                          {item.name}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>

            {loading ? (
              <div className="admin-page-section">
                <CustomLoader />
              </div>
            ) : (
              pageData && (
                <div className="admin-page-table-wrap">
                  <table className="admin-page-table">
                    {pageData?.objects?.length > 0 && (
                      <thead>
                        <tr>
                          <th>School Name</th>
                          <th>Last SFTP Date</th>
                          <th>SFTP Status</th>
                        </tr>
                      </thead>
                    )}
                    <tbody>
                      {pageData?.objects?.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.school_name}</td>
                          <td>
                            {moment(item.date_created).format(
                              "ddd MMM Do YYYY, hh:mm:ss a"
                            )}
                          </td>
                          <td>
                            <span className="admin-page-status">
                              {item?.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SftpDetails;
